import * as React from 'react';

import { Tooltip, EXTRA_SMALL_ICON_BASE_SRC, } from '../../../../Shared/index';

interface AssignmentCardProps {
  selectCard?: () => void;
  imgSrc?: string;
  imgAlt?: string;
  header: string;
  bodyArray: Array<{ key: string, text: string }>;
  buttonText?: string;
  buttonLink?: string;
  imgClassName?: string;
  showNewTag?: boolean;
  showRecommendedToStartTag?: boolean;
  lockedText?: string;
  preHeader?: string;
  showNewTagInPreHeaderLine?: boolean;
  callout?: JSX.Element;
}

export default class AssignmentCard extends React.Component<AssignmentCardProps, {}> {

  handleClick = (e) => {
    const { selectCard, lockedText, } = this.props
    if (e.target.tagName !== 'A' && !lockedText) {
      selectCard()
    }
  }

  handleAnchorClick = (e) => e.stopPropagation();

  renderButtons = () => {
    const { buttonText, buttonLink, selectCard, lockedText, } = this.props;
    /* eslint-disable react/jsx-no-target-blank */
    const button = buttonText && buttonLink ? <a className="quill-button small borderless grey focus-on-light" href={buttonLink} onClick={this.handleAnchorClick} target="_blank"><img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/eye.svg`} /><span>{buttonText}</span></a> : null;
    /* eslint-enable react/jsx-no-target-blank */
    const selectButton = <button className="quill-button small contained green focus-on-light" onClick={selectCard} type="button">Select</button>
    const lockedButton = <Tooltip tooltipText={lockedText} tooltipTriggerText={<button className="quill-button small disabled contained" type="button">Locked</button>} />
    if (button) {
      return (
        <div className="button-container">
          {button}
          {lockedText ? lockedButton : selectButton}
        </div>
      );
    } else {
      return button;
    }
  }

  render() {
    const { imgSrc, imgAlt, imgClassName, showNewTag, header, bodyArray, showRecommendedToStartTag, preHeader, showNewTagInPreHeaderLine, buttonText, buttonLink, callout, } = this.props
    const bodyElements = bodyArray.map(obj => (
      <div className="body-element" key={obj.key}>
        <p className="key">{obj.key}</p>
        <p className="text">{obj.text}</p>
      </div>)
    )

    const newTagElement = <span className="gold-new-tag">NEW</span>
    const newTag = showNewTag ? newTagElement : null
    const newTagInPreHeaderLine = showNewTagInPreHeaderLine ? newTagElement : null
    const recommendedToStartTag = showRecommendedToStartTag ? <span className="recommended-to-start-tag">Recommended to start</span> : null
    const preHeaderTag = preHeader ? <span className="pre-header">{preHeader}</span> : null
    const leftClassName = showRecommendedToStartTag ? "left include-recommended-to-start-tag" : "left"

    // Reference the body content for screen reader description
    // Sanitize header to create a valid HTML ID
    const descriptionId = `${header.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()}-description`

    const content = (
      <React.Fragment>
        {newTag}
        <div className="top-row">
          <div className={leftClassName}>
            {imgSrc && <img alt={imgAlt} className={imgClassName} src={imgSrc} />}
            <div className="header-wrapper">
              {recommendedToStartTag}
              {preHeaderTag ? <div className="pre-header-wrapper">{preHeaderTag}{newTagInPreHeaderLine}</div> : null}
              <h2 id={header}>{header}</h2>
            </div>
          </div>
          {this.renderButtons()}
        </div>
        <div className="body" id={descriptionId}>
          {bodyElements}
        </div>
        {callout}
      </React.Fragment>
    )

    const className = `${newTag ? 'show-new-tag' : ''} assignment-card quill-card focus-on-light`

    if (buttonText && buttonLink) {
      // we don't want the entire element to be a button if it renders a button within it, because it creates a redundant and verbose experience for SR users,
      // so we're disabling this linter rule because there is still a button here that SR users can interact with

      /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
      return (
        <section aria-describedby={descriptionId} aria-labelledby={header} className={className} onClick={this.handleClick}>
          {content}
        </section>
      )
      /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
    }

    return (
      <button aria-describedby={descriptionId} aria-labelledby={header} className={className} onClick={this.handleClick} type="button">
        {content}
      </button>
    )
  }
}
